import {
  Body,
  Box,
  BoxProps,
  Button,
  Heading,
  Link,
  Stack,
} from '@hover/blueprint';
import React, { useState } from 'react';
import { ISharedHeroContent } from '../../../interfaces/ISharedHero';
import ArrowButton from '../ArrowButton';
import DownloadAppModal from '../download-app-modal';

interface Props extends ISharedHeroContent, BoxProps {
  haveBackground?: boolean;
}

const Content: React.FC<Props> = ({
  heading,
  body,
  openModalButtonTitle,
  openModalButtonLink: OpenModalButtonLink,
  chatWithUsLink,
  chatWithUsLinkTitle,
  haveBackground,
  children,
  haveContentChildren = true,
  ...restProps
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => setIsOpen(!isOpen);

  const renderChildren = () => {
    if (haveContentChildren) {
      if (children) {
        return children;
      }
      return (
        <Stack
          w={{ base: '100%', tablet: 'auto' }}
          direction={{ base: 'column', tablet: 'row' }}
          spacing={{ base: 400, tablet: 500 }}
        >
          {openModalButtonTitle ? (
            <Button
              as={Link}
              size="large"
              style={{ color: 'white', cursor: 'pointer' }}
              w={{ base: '100%', tablet: 'auto' }}
              href={OpenModalButtonLink}
            >
              {openModalButtonTitle}
            </Button>
          ) : (
            <Button
              size="large"
              w={{ base: '100%', tablet: 'auto' }}
              onClick={toggleModal}
            >
              GET STARTED
            </Button>
          )}
          {chatWithUsLink && (
            <ArrowButton
              as={Link}
              href={chatWithUsLink}
              variant="minimal"
              w={{ base: '100%', tablet: 'auto' }}
              sx={{
                // TODO(buttons): remove when we remove padding in Blueprint
                div: { pl: 0, pr: 50 },
              }}
            >
              {chatWithUsLinkTitle || 'Chat with us'}
            </ArrowButton>
          )}
        </Stack>
      );
    }
    return null;
  };

  return (
    <>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Box
        mt={{ base: 700, desktop: 0 }}
        mx={{ base: 0, tablet: 'auto' }}
        pl={500}
        pr={{ base: 500, desktop: 0 }}
        maxW={{ base: '100%', tablet: '800px', desktop: '570px' }}
        flexDir="column"
        justifyContent="center"
        alignItems={{ base: 'center', desktop: 'flex-start' }}
        className="shared-hero__content"
        {...restProps}
      >
        <Heading
          maxW={{ base: '100%', tablet: '800px', desktop: '570px' }}
          textAlign={{ base: 'center', desktop: 'left' }}
          marginBottom={{ base: 500, tablet: 500, desktop: 500 }}
          fontWeight={700}
          size={{ base: 600, tablet: 700, desktop: 800 }}
          color={haveBackground ? 'neutral.0' : 'neutral.900'}
          className="shared-hero__heading"
        >
          {heading}
        </Heading>
        <Body
          color={haveBackground ? 'neutral.0' : 'neutral.900'}
          mb={700}
          textAlign={{ base: 'center', desktop: 'left' }}
          whiteSpace="pre-wrap"
          className="shared-hero__body"
        >
          {body}
        </Body>
        {renderChildren()}
      </Box>
    </>
  );
};

export default Content;
